import { Action } from 'typescript-fsa'

import { GeneralError } from '../Interfaces/ErrorInterfaces'

export const addGeneralError = (error: GeneralError): Action<GeneralError> => ({
  type: 'ERROR_ADD',
  payload: error,
  error: true,
})

export const removeGeneralError = (error: GeneralError): Action<GeneralError> => ({
  type: 'ERROR_REMOVE',
  payload: error,
  error: true,
})

export const removeGeneralErrorWithKey = (key: string): Action<string> => ({
  type: 'ERROR_REMOVE_WITH_KEY',
  payload: key,
  error: true,
})
